<template>
<div id="edit_info">
    <div id="main">
        <div id="edit_myinfo">
            <div id="header">
                <div class="header-wrap">
                    <div class="top-menu-bar">
                        <div class="back" @click="go_mypage()">
                            <a href="#">
                                <img src="../../assets/images/back.png" alt="icon-menu">
                            </a>
                        </div>
                        <h1 class="page-title">
                            <a href="#">
                                <span>내 정보 변경</span>
                            </a>
                        </h1>
                        <div class="mypage">
                            <a href="#">

                            </a>
                        </div>
                        <div class="bottom-radius"></div>
                    </div>
                </div>
            </div>
            <div class="account-wrap">
                <div class="my-account">
                    <div class="edit-title">로그인계정</div>
                    <div>
                        <ul>
                            <li>
                                <div class="myinfo-contitle"><span>아이디</span></div>
                                <div class="myinfo-content disabled"><span>{{user_m_account_id}}</span></div>
                            </li>
                            <li>
                                <div class="myinfo-contitle"><span>이름</span></div>
                                <div class="myinfo-content disabled"><span>{{name}}</span></div>
                            </li>
                            <li>
                                <div class="myinfo-contitle"><span>휴대폰번호</span></div>
                                <div class="myinfo-content disabled"><span>{{user_hp}}</span></div>
                            </li>
                            <li>
                                <div class="myinfo-contitle"><span>부모님 휴대폰 번호</span></div>
                                <div class="myinfo-content"><input type="text" id="parent-number" name="parent-number" placeholder="ex) 010-0000-0000" v-on:input="autoHyphen_parent" v-bind:value="parents_hp" /><label for="parent-number" class="hidden"></label></div>
                            </li>
                            <li>
                                <div class="myinfo-contitle"><span>주소</span></div>
                                <!-- 코드 추가 - 2020-12-21 -->
                                <div class="edit-address">
                                    <div class="myinfo-content"><input type="address" id="address" name="address" v-model="address" readonly /><label for="address" class="hidden"></label></div>
                                    <div class="btn-ok btn-confirm"  @click="searchAddress" style=""><span>주소찾기</span></div>
                                </div>
                            </li>
                            <li>
                                <div class="myinfo-contitle"><span>상세주소</span></div>

                                <div class="myinfo-content"><input type="address" id="address" name="address" placeholder="ex) B동 401호" v-model="address_detail" /><label for="address" class="hidden"></label></div>
                            </li>
                            <li>
                                <div class="myinfo-contitle"><span>성별/생년월일</span></div>
                                <div class="gender-birth">
                                    <div class="gender-input">
                                        <label for="sex" class="hidden">성별</label>
                                        <label for="gender_check">남</label>
                                        <input type="radio" name="sex_male" id="sex_male" value="male" v-model="gender">
                                        <label for="gender_check">여</label>
                                        <input type="radio" name="sex_female" id="sex_female" value="female" v-model="gender">
                                    </div>
                                    <div class="birth-input">
                                        <div class="myinfo-content"><input type="text" id="birth" name="birth" placeholder="ex)19990101" v-model="birth" maxlength="8" /><label for="birth" class="hidden"></label></div>
                                    </div>
                                </div>
                            </li> 
                            <li class="btn-myinfo">
                                <div class="btn-save" @click="update_user_info"><span>저장</span></div>
                                <div @click="edit_password" class="btn-editpass"><span>비밀번호 변경</span></div>
                                <div class="btn-delete" @click="delete_user_info"><span>회원탈퇴</span></div>
                            </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';
export default {
    name: 'edit_info',
    components: {},
    data() {
        return {
            name: '',
            user_hp: '',
            gender: null,
            parents_hp: '',
            birth: '',
            address: '',
            address_detail: '',
            m_user_id: '',
            join_datetime: '',

        }
    },
    mounted() {
        this.$nextTick(function () {
            var user_info = this.$store.getters['getUser_info'];
            console.log(user_info);
            this.name = user_info.value.name;
            this.user_hp = user_info.value.user_hp;
            if (user_info.value.sex == 0) {
                this.gender = 'male';
            } else if (user_info.value.sex == 1) {
                this.gender = 'female';
            }else {
                this.gender = '';
            }
            //  코드 추가 - 2020-12-21
            this.user_m_account_id = user_info.value.user_m_account_id; 
            this.parents_hp = user_info.value.parents_hp;
            this.birth = user_info.value.age;
            this.address = user_info.value.address;
            this.address_detail = user_info.value.address_detail;
            this.m_user_id = user_info.value.m_user_id;
            this.join_datetime = user_info.value.join_datetime;

        });

    },
    methods: {
        update_user_info() {
            if (this.gender == 'male') {
                this.gender = 0;
            }
            if (this.gender == 'female') {
                this.gender = 1;
            }
            
            if(this.birth == null){
                this.birth = 0;
            }
            if(this.birth == ''){
                this.birth = 0;
            }
            var data = {
                address: this.address,
                birth: this.birth,
                address_detail: this.address_detail,
                sex: this.gender,
                m_user_id: this.m_user_id
            }
            var type = config.REQ_INFO_EDIT;
            common.getData(type, data,
                (response) => {
                    if (response.result == true) {
                        var data = {
                            code: 103,
                            message: '정보가 변경되었습니다.'
                        };
                        EventBus.$emit('popup-data', data);
                        var data = {}
                        data.address = this.address;
                        data.address_detail = this.address_detail;
                        data.age = this.birth;
                        data.agree_yn = 1;
                        data.blacklist_yn = 0;
                        data.join_datetime = this.join_datetime;
                        data.m_user_id = this.m_user_id;
                        data.name = this.name
                        data.parents_hp = this.parents_hp;
                        data.sex = this.gender;
                        data.user_hp = this.user_hp;
                        this.$store.commit('setUser_info', {
                            value: data
                        });
                        if (this.gender == 0) {
                            this.gender = 'male';
                        }
                        if (this.gender == 1) {
                            this.gender = 'female';
                        }
                    }
                })
        },
        delete_user_info() { 
            var data = { 
                code: 104,
                message: '탈퇴시 복구가 불가능합니다.<br>회원 탈퇴하시겠습니까?'
            };    
            EventBus.$emit('popup-data', data);
        },
        go_mypage() {
            this.$router.push('/mypage');
        },
        edit_password() {
            this.$router.push('/edit_password');
        },
        searchAddress() {
            var self = this;
            var callback = function (result) {
                self.address = result.address;
            };
            getSearchAddress(callback);
        },
        autoHyphen_parent(e) {
            this.parents_hp = e.target.value;
            var num = /^[0-9 \-]*$/;
            if (!num.test(this.parents_hp)) {
                var str = this.parents_hp;
                str = str.substr(0, str.length - 1);
                this.parents_hp = str;
            }

            if (this.parents_hp.length > 13) {
                this.parents_hp = this.parents_hp.substr(0, 13);
            } else {
                var val = this.parents_hp.replace(/\D/g, '');
                var original = this.parents_hp.replace(/\D/g, '').length;
                var conversion = '';
                for (let i = 0; i < 3; i++) {
                    if (val.length > 3 && i === 0) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 6 && val.length > 3 && i === 1) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 10 && val.length < 12 && i === 2) {
                        let value = this.parents_hp.replace(/-/gi, "");
                        conversion = '';
                        this.parents_hp = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7, 11);
                        return this.parents_hp;
                    }
                }
                conversion += val;
                this.parents_hp = conversion;
            }
        },

    },
    watch: {
        birth(val) {
            if (this.birth != null) {
                var reg = /^[0-9 \-]*$/;
                if (!reg.test(this.birth)) {
                    var str = this.birth;
                    str = str.substr(0, str.length - 1);
                    this.birth = str;
                }
            }

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped> 

    .account-wrap .my-account div ul li.btn-myinfo .btn-delete {
        background-color: #ec4c4c; color: #fff; margin-top: 10px; margin-bottom: 15px; 
    } 

</style>



// WEBPACK FOOTER //
// src/components/page/EditInfoPage.vue